// src/pages/LoginPage.js
import { React, useState } from 'react';
import { Box, Container, CssBaseline, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Login from './Login';
import axios from 'axios';
import api from './api';

const LoginPage = ({ setIsAuthenticated, setUser_Id, setIsAdmin, setUser }) => {

  const [showResetEmailForm, setShowResetEmailForm] = useState(false);
  const [resetEmail, setResetEmail] = useState("");

  const handleSendResetLink = async () => {
    try {
      const res = await api.post("/api/request-password-reset", {
        email: resetEmail,
      });
      alert("パスワードリセットの案内を送信しました。");
      setShowResetEmailForm(false);
    } catch (err) {
      console.error(err);
      alert("メールアドレスが見つかりませんでした。");
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
      }}
    >
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none !important;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        .sm-w-65-100 {width: 100%;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        .sm-w-65-100 {width: 65%;}
        .extra {display: none;}
        }
        `}
       </style>
      <CssBaseline />
      <div style={{display: 'flex'}}>
        <div style={{width: '35%',textAlign: 'right', padding: '15% 0', height: '100vh' }} className='sm-none'>
          <div style={{ width: '60%', margin: '0 auto' }}>
            {/* <img src="/messe-icon.png" alt="icon"  style={{ maxWidth: '100%', height: 'auto' }}/> */}
            <img src="/logo.png" alt="logo"  style={{ maxWidth: '100%', height: 'auto' }}/>
            <Typography>SDGs 子ども・ユースフェア<br />出展者申請システム</Typography>
          </div>
        </div>
        <div style={{ backgroundColor: '#efefef'}} className='sm-w-65-100'>
          <div style={{padding: '15% 0' }} className='sm-block sm-w-65-100 extra'>
            <div style={{ width: '100%', margin: '0 auto',textAlign: 'center' }}>
              {/* <img src="/messe-icon.png" alt="icon"  style={{ maxWidth: '100%', height: 'auto' }}/> */}
              <img src="/logo.png" alt="logo"  style={{ maxWidth: '100%', height: 'auto' }}/>
              <Typography>SDGs 子ども・ユースフェア<br />出展者申請システム</Typography>
            </div>
          </div>
          <Login
            setIsAuthenticated={setIsAuthenticated}
            setUser_Id={setUser_Id}
            setIsAdmin={setIsAdmin}
            setUser={setUser}
          />
          <Box style={{textAlign: 'center'}}>
              <p style={{ color: 'blue', cursor: 'pointer' }} onClick={() => setShowResetEmailForm(true)}>
                パスワードを忘れた方はこちら
              </p>
          </Box>
          {showResetEmailForm && (
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <input
                type="email"
                placeholder="登録済みメールアドレスを入力"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
              />
              <button onClick={handleSendResetLink}>送信</button>
            </div>
          )}
        </div>
      </div>
    </Box>
  );
};

export default LoginPage;
